const routes = [
  {
    path: "/lineasdeprecio",
    component: () =>
      import(/* webpackChunkName: "lineasdeprecio" */ "./Lineasprecio"),
  },
];
export default routes;
